import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../layouts/shared-service';
import { CustomValidators } from 'ng2-validation';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Router} from '@angular/router';
import { MdDialog, MdDialogRef, MdDialogConfig } from '@angular/material';
import { environment } from 'environments/environment.prod';
const breadcrumb: any[] = [
  {
    title: 'Home'
    //link: 'default-layout/dashboard'
  },
  {
    title: 'User'
    //link: '#/default-layout/user'
  },
  {
    title: 'Add user'
    //link: ''
  }
];

//const password = new FormControl('', Validators.required);
//const confirmPassword = new FormControl('', CustomValidators.equalTo(password));

@Component({
  selector: 'page-user-add',
  templateUrl: './user-add.html',
  styleUrls: ['./user-add.scss']
})


export class PageUserAdd implements OnInit {
  pageTitle: string = environment.sysName;
  breadcrumb: any[] = breadcrumb;
  public form: FormGroup;
  data: any;
  permissionStr:string;
  permissionShow:string;
  permissionsMobilesStr:string;
  permissionsMobilesShow:string;
  permissions = [
    { value: '1', viewValue: 'Administrator' },
    { value: '2', viewValue: 'CEO' },
    { value: '3', viewValue: 'PC1' },
    { value: '4', viewValue: 'PC2' },
    { value: '5', viewValue: 'PU' },
    { value: '6', viewValue: 'QC' },
    { value: '7', viewValue: 'PD' }
   
  ];
  
  permissionsMobiles = [
    { value: '0', viewValue: 'N/A' },
    { value: '1', viewValue: 'Plan matterial'},
    { value: '11', viewValue: 'Plan platting' },
    { value: '2', viewValue: 'Receive Material' },
    { value: '6', viewValue: 'Receive platting' },
    { value: '3', viewValue: 'Dandoriman' },
    { value: '5', viewValue: 'Collect platting' },
    { value: '7', viewValue: 'Packing' },
    { value: '8', viewValue: 'Collect and Sale' },
    { value: '9', viewValue: 'Quality Control' },
    { value: '10', viewValue: 'Change lot size' },
    { value: '12', viewValue: 'Production' }
  ];
  //diaglog
  dialogRef: MdDialogRef<userAddDialog>;
  selectedOption: string;


  constructor(public dialog: MdDialog,private fb: FormBuilder, private _sharedService: SharedService,private router: Router) {

    this._sharedService.emitChange(this.pageTitle);
   // this.permissionStr="ผู้ดูแลระบบ";
  }

  
    openDialog() {
    let dialogRef = this.dialog.open(userAddDialog);
     dialogRef.afterClosed().subscribe(result => {
      //this.selectedOption = result;
      
      if(result==='1'){
        this.postString();
        console.log('---result---',result);
       // alert('postString');
      }else{
        console.log('---result---',result);
       // alert('cancel');
      }

    });
  }



  postString() {
    this.data = "permissionmobile="+this.permissionsMobilesStr+"&permission="+this.permissionStr+"&user="+this.form.controls.user.value+"&password="+this.form.controls.password.value+"&address="+this.form.controls.address.value+"&name="+this.form.controls.name.value.replace(/&/g, '^')+"&email="+this.form.controls.email.value+"&phone=" + this.form.controls.phone.value;
    const req = new XMLHttpRequest();
    req.open('POST',  environment.url+'/api/insertDataUser.php', true);

    //Send the proper header information along with the request
    req.setRequestHeader("Content-type", "application/x-www-form-urlencoded");

    req.onreadystatechange = function () {//Call a function when the state changes.
      if (req.readyState == XMLHttpRequest.DONE && req.status == 200) {
        // Request finished. Do processing here.
        req.onload = () => {
          console.log(JSON.parse(req.response));
          //JSON.parse(req.response);
        };
      }
    }
    req.send(this.data);
    console.log('----data-----', this.data);

  
  this.router.navigateByUrl('default-layout/user');

  }


  getPermission(permission,permissionShow) {
    this.permissionStr = permission;
    this.permissionShow = permissionShow;
    console.log('permission',permission);
  }
  getPermissionMobile(permissionMobile,permissionsMobilesShow) {
    this.permissionsMobilesStr = permissionMobile;
    this.permissionsMobilesShow = permissionsMobilesShow;
    console.log('permission',permissionMobile);
  }

  ngOnInit() {

    this.form = this.fb.group({
      //stateCtrl: [null, Validators.compose([Validators.required])],
      name: [null, Validators.compose([Validators.required])],
      
      phone: [null, Validators.compose([Validators.required])],
      email: [null, Validators.compose([Validators.required])],
      user: [null, Validators.compose([Validators.required])],
      password: [null, Validators.compose([Validators.required])],
      address: [null, Validators.compose([Validators.required])]
      
      //color: [null, Validators.compose([Validators.required])],
      // unit: [null, Validators.compose([Validators.required])]
      //email: [null, Validators.compose([Validators.required, CustomValidators.email])],
      //range: [null, Validators.compose([Validators.required, CustomValidators.range([5, 9])])],
      //url: [null, Validators.compose([Validators.required, CustomValidators.url])],
      //date: [null, Validators.compose([Validators.required, CustomValidators.date])],
      //creditCard: [null, Validators.compose([Validators.required, CustomValidators.creditCard])],
      //phone: [null, Validators.compose([Validators.required, CustomValidators.phone('en-US')])],
      //gender: [null, Validators.required],
      //password: password,
      //confirmPassword: confirmPassword

    });



  }
}

//dialog
@Component({
  selector: 'user-dialog',
  templateUrl: 'dialog.html',
})
export class userAddDialog {
  Message = 'What would you like to do?';
  constructor(public dialogRef: MdDialogRef<userAddDialog>) {}
}



// WEBPACK FOOTER //
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/app/pages/user/user-add.ts